import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-02c3da87"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "flex" };
var _hoisted_2 = {
    key: 0,
    class: "w-full"
};
var _hoisted_3 = { class: "tooltip" };
var _hoisted_4 = { class: "tooltip__text" };
var _hoisted_5 = { class: "w-full" };
import { PlanContentStore } from '@school/modules/store';
import { PLANS } from '@school/modules/stores/planContentStore';
import { computed } from 'vue';
import ETooltip from '@common/ui/ETooltip.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PlanContent',
    props: {
        plan: {},
        title: {},
        image: {},
        disabled: { type: Boolean },
        blockContent: { type: Boolean }
    },
    emits: ["click"],
    setup: function (__props) {
        var props = __props;
        var localPlan = computed(function () { return PLANS.find(function (p) { return p.name === props.plan; }); });
        var planIcon = computed(function () { return localPlan.value.icon; });
        var showModal = function () {
            PlanContentStore.show(localPlan.value.name, props.title, props.image);
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_ctx.disabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "default")
                    ]))
                    : (_openBlock(), _createBlock(ETooltip, {
                        key: 1,
                        theme: "light",
                        trigger: "hover",
                        unselectable: ""
                    }, {
                        tooltip: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_e_icon, {
                                    icon: planIcon.value,
                                    class: "tooltip__icon"
                                }, null, 8, ["icon"]),
                                _createElementVNode("p", _hoisted_4, [
                                    _createTextVNode(" Доступно на тарифе "),
                                    _createElementVNode("span", null, " «" + _toDisplayString(_ctx.plan) + "» ", 1)
                                ])
                            ])
                        ]; }),
                        default: _withCtx(function () { return [
                            _createElementVNode("div", {
                                class: _normalizeClass([{ 'content--blocked': _ctx.blockContent }, "content"]),
                                onClick: showModal
                            }, [
                                _createElementVNode("div", _hoisted_5, [
                                    _renderSlot(_ctx.$slots, "default")
                                ])
                            ], 2)
                        ]; }),
                        _: 3
                    }))
            ]));
        };
    }
});
